import styled from 'styled-components';
import { StyledLineProps } from './types';

/**
 * Component style.
 */
export const StyledLine = styled('g')<StyledLineProps>``;
